import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import ChatHome from "../pages/Home/Chat";

const Stack = createNativeStackNavigator();

export default function ChatStack() {
    return (
        <Stack.Navigator>
            <Stack.Screen
                name="ChatHome"
                component={ChatHome}
                options={{ headerShown: false }}
            />
        </Stack.Navigator>
    );
}
